import React from 'react'
import Modal from 'react-modal';

Modal.setAppElement('#root');
const ModalConfirm = (props) => {

    const { data, onClose, onConfirm } = props

    return (
        <Modal
            isOpen={data.show}
            contentLabel=""
            className="modal-content modal-sm"
            overlayClassName="modal-overlay"
            onRequestClose={onClose}>
            <div className="p-2" style={{ minWidth: '300px' }}>
                <p className="card-title font-weight-bolder">{data.title}</p>
                {/* <h6 className="card-title">{data.title}</h6> */}
                <p className="small card-text text-break">{data.message}</p>

                <div className="d-flex flex-row-reverse">
                    <button onClick={onConfirm} type="submit" className="btn btn-sm btn-success mr-1 ml-1" style={{ width: 40 }}>Si</button>
                    <button onClick={onClose} className="btn btn-sm btn-secondary mr-1 ml-1" style={{ width: 40 }}>No</button>
                </div>

            </div>
        </Modal>
    );
}

export default ModalConfirm;